var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowed)?_c('div',[_vm._t("default")],2):_c('div',[(_vm.login)?_c('LoginCard'):_vm._e(),_c('b-loading',{attrs:{"active":!_vm.login,"is-full-page":false,"can-cancel":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }